// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyBUaOjEdo2YnPPi1m-KMLHYSDPjvQw6Xgw',
    authDomain: 'crime-alert-eea56.firebaseapp.com',
    projectId: 'crime-alert-eea56',
    storageBucket: 'crime-alert-eea56.appspot.com',
    messagingSenderId: '726139640067',
    appId: '1:726139640067:web:12f638e4b35b8550817136',
    measurementId: 'G-GHBXL5QHQ6'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
